import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path, type = 'website' }) => {
  const siteName = 'AFHOS';
  const baseUrl = 'https://afhos.africa';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | African Federation of Hypertension Organisations and Societies`;
  const fullUrl = path ? `${baseUrl}${path}` : baseUrl;
  const defaultDesc = 'Uniting national societies, researchers, and health partners to prevent and control high blood pressure across Africa.';
  const desc = description || defaultDesc;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};

export default SEO;
